export enum MediaSize {
    XSMALL,
    SMALL,
    MEDIUM,
    LARGE,
    XLARGE,
}

export enum DeviceOrientation {
    portrait,
    landscape,
}
